<template>
  <el-card shadow="never" class="aui-card--fill">
  <div class="mod-config">
     <el-form
        :inline="true"
        :model="dataForm"
        @keyup.enter.native="getDataList()"
      >
        <el-form-item>
          <el-select  v-model="dataForm.userId" filterable clearable placeholder="用户">
            <el-option v-for="item in  fundList" :key="item.userId" :value="item.userId" :label="item.userName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
            <el-date-picker
                    v-model="date"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                     :default-time="['00:00:00','23:59:59']"
                     value-format="yyyy-MM-dd HH:mm:ss"
                    @change="getTimes"
                    unlink-panels>
            </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-select v-model="dataForm.status" filterable clearable placeholder="状态">
            <el-option v-for="item in statusList" :key="item.value" :value="item.value" :label="item.label"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <div class="btn">
            <el-button @click="getDataList('dept')">{{ $t("query") }}</el-button>
          </div>
        </el-form-item>
        <el-form-item>
          <div class="btn" v-if="$hasPermission('system:ip:save')">
            <el-button type="primary" @click="addOrUpdateHandle()">新增</el-button>
          </div>
        </el-form-item>
      </el-form>
    <el-table
      :data="dataList"
      border
      v-loading="dataListLoading"
      @selection-change="selectionChangeHandle"
      style="width: 100%;">
      <el-table-column
        type="selection"
        header-align="center"
        align="center"
        width="50">
      </el-table-column>
      <el-table-column
        prop="orgName"
        header-align="center"
        align="center"
        label="公司名称">
      </el-table-column>
      <el-table-column
        prop="userId"
        header-align="center"
        align="center"
        label="用户">
        <template slot-scope="scope">
         {{ getDictLabel(scope.row.userId) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="ipCidr"
        header-align="center"
        align="center"
        label="IP地址"
        width="160"
        >
          <template slot-scope="scope">
            <span v-html="scope.row.ipCidr.replace(/,/g, '<br>')"></span>

          </template>
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="状态">
        <template slot-scope="scope">
          <span v-if="scope.row.status === 0">失效</span>
          <span v-else-if="scope.row.status === 1">有效</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="startTime"
        header-align="center"
        align="center"
        label="生效时间">
      </el-table-column>
      <el-table-column
        prop="endTime"
        header-align="center"
        align="center"
        label="失效时间">
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否跳过IP检查">
        <template slot-scope="scope">
          <span v-if="scope.row.skipIpCheck === 0">不跳过</span>
          <span v-else-if="scope.row.skipIpCheck === 1">跳过</span>
          <span v-else>未知</span>
        </template>
      </el-table-column>
      <el-table-column
        prop="skipIpStartTime"
        header-align="center"
        align="center"
        label="临时访问开始时间">
      </el-table-column>
      <el-table-column
        prop="skipIpEndTime"
        header-align="center"
        align="center"
        label="临时访问结束时间">
      </el-table-column>
      
      <el-table-column
        prop="createDate"
        header-align="center"
        align="center"
        label="创建时间">
      </el-table-column>
     
      <el-table-column
        prop="updateDate"
        header-align="center"
        align="center"
        label="修改时间">
      </el-table-column>
      <el-table-column
        prop="remark"
        header-align="center"
        align="center"
        label="备注">
      </el-table-column>
      <el-table-column
        fixed="right"
        header-align="center"
        align="center"
        width="150"
        label="操作">
        <template slot-scope="scope">
          <el-button type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">修改</el-button>
          <el-button type="text" size="small" @click="deleteHandle(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
          <el-pagination
        :current-page="page"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="limit"
        :total="total"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="pageSizeChangeHandle"
        @current-change="pageCurrentChangeHandle">
      </el-pagination>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
  </div>
  </el-card>
</template>

<script>
  import mixinViewModule from '@/mixins/view-module'
  import AddOrUpdate from './useripwhitelist-add-or-update'
  export default {
     mixins: [mixinViewModule],
    data () {
      return {
        mixinViewModuleOptions: {
          getDataListURL: '/system/ip/page',
          getDataListIsPage: true,
        },
        date:null,
        dataForm: {
          userId: null,
          status: null,
          startTime: null,
          endTime: null
        },
        dataList: [],
        statusList: [
          {value: 0, label: '失效'},
           {value: 1, label: '有效'}
          ],
        fundList:[],  
        dataListLoading: false,
        dataListSelections: [],
        addOrUpdateVisible: false
      }
    },
    components: {
      AddOrUpdate
    },  
    created () {
      this.getDataList(),
      this.$http.get('/sys/user/queryUserList').then(res=>{
        this.fundList = res.data.data
      })
    },
    methods: {
      getDictLabel(value) {
      const dictItem = this.fundList.find(item => item.userId == value);
      return dictItem ? dictItem.userName : ''; 
    },
      // 多选
      selectionChangeHandle (val) {
        this.dataListSelections = val
      },
      //新增或者删除
      addOrUpdateHandle(id) {
        this.addOrUpdateVisible = true
        this.$nextTick(() => {
          if (!id) {
            this.$refs.addOrUpdate.init()
          } else {
            this.$refs.addOrUpdate.init(id)
          }
        })
      },
      // 删除
      deleteHandle (id) {
         const ids = id ? [id] : this.dataListSelections.map(item => item.id);
        this.$confirm(`确定对[id=${ids.join(',')}]进行[${id ? '删除' : '批量删除'}]操作?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.$http.delete('/system/ip/delete', { data:ids}).then(({data}) => {
            if (data && data.code === 0) {
              this.$message({
                message: '操作成功',
                type: 'success',
                duration: 1500,
                onClose: () => {
                  this.getDataList()
                }
              })
            } else {
              this.$message.error(data.msg)
            }
          })
        })
      },
      getTimes() {
        if (this.date != null) {
          this.dataForm.startTime = this.date[0]
          this.dataForm.endTime = this.date[1]
        } else{
          this.dataForm.startTime =null
          this.dataForm.endTime =null
        }
    },
    }
  }
</script>
